import React, { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react';
import { NavMenu } from '../components';
import { SpeedLadderResult } from '../components/speedLadder/result';
import SpeedLadderAnalysis from '../components/speedLadder/analysis';
import { SpeedLadderPick } from '../components/speedLadder/pick';
import { RoomChatList } from '../components/roomChat';
import clsx from 'clsx';
import { useLocation } from 'react-router-dom';
import Seo from '../../../components/seo';
import BannerGA from '../../../components/banner/BannerGA';
import { Url } from '../../../common/constants/environment';
import BetSection from '../betSection';
import { BannerList } from '../components/banner';

const SpeedLadder = observer(({ history }) => {
  const { pathname } = useLocation();
  const query = new URLSearchParams(history.location.search);
  const tab = query.get('tab') || 'result';
  const [isSmallView, toggleSmallView] = useState(false);
  const [tabSelect, setTabSelect] = useState();
  const gameName = pathname?.split('/')[3];

  useEffect(() => {
    toggleSmallView(false);
  }, [tab]);

  useEffect(() => {
    history.push(`${pathname}?tab=banner`)
  }, [pathname, tabSelect]);

  const component = useMemo(() => {
    switch (tab) {
      case 'banner':
        return <BannerList space={'powerladder'} />
      case 'room_chat':
        return <RoomChatList roomType={'lottery'} />;
      case 'result':
        return <SpeedLadderResult />;
      case 'analysis':
        return <SpeedLadderAnalysis />;
      case 'pick':
        return <SpeedLadderPick />;
      default:
        return <SpeedLadderResult />;
    }
  }, [tab, isSmallView]);

  return (
    <>
      <Seo title={'스피드사다리'} />
      <div className='minigame_wrap'>
        <div className={clsx('game_view', 'ladder')}>
          <iframe
            scrolling='no'
            frameBorder='0'
            src={Url.namedWeb + 'minigame/ladder/speedladder/view.php?view_mode=m'}
          />
        </div>
        <BetSection gameType={gameName} />
        <NavMenu />
        {component}
      </div>

      {/* NEW ADS #1 구글 검열로 인해 비활성화*/}
      {/*<BannerGA*/}
      {/*    containerStyle={{*/}
      {/*      display: 'block',*/}
      {/*      width: 450,*/}
      {/*      height: 50,*/}
      {/*      marginTop: 16,*/}
      {/*    }}*/}
      {/*    gaSlot={'5003058707'}*/}
      {/*    width={450}*/}
      {/*    height={50}*/}
      {/*/>*/}
    </>
  );
});

export default SpeedLadder;
